import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Swal from "sweetalert2";
import '@sweetalert2/theme-dark/dark.scss';
import DatePicker from "react-date-picker";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import "../../layout/styles/components/date-picker.scss";
import {
  delCmnctCctvImg,
  delCmnctCctvInfo,
  getCmnctCctvInfo,
  putCmnctCctvInfo,
  regCmnctCctvInfo
} from "../../api/apiClient";
import Moment from "moment";
import ComboDistrict from "../../components/inputs/ComboDistrict";

const ConfCctvReg = ({
                       propCctvNo,
                       hClose
                     }) => {

  const [cctvInfo, setCctvInfo] = useState({
    instl_de: Moment(new Date()).format('YYYY-MM-DD'),
  });

  const updateSystemInfo = () => {
    if (propCctvNo) {
      getCmnctCctvInfo(propCctvNo)
          .then(response => {
            console.log(response);
            if (response.data.data !== undefined) {
              setCctvInfo(response.data.data);
            }
          });
    }
  };

  useEffect(() => {
    updateSystemInfo();
  }, []);

  useEffect(() => {
    console.log(cctvInfo);
  }, [cctvInfo]);

  const onChangeInfo = (name, value, isMany) => {
    let newInfo = {...cctvInfo};
    if (isMany) {
      for (let i = 0; i < name.length; i++) {
        newInfo[name[i]] = value[i];
      }
    } else {
      newInfo[name] = value;
    }
    setCctvInfo(newInfo);
  };

  const onSubmit = () => {
    if (!cctvInfo.cctv_nm) {
      Swal.fire(
          'CCTV명은 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!cctvInfo.cctv_pole_no) {
      Swal.fire(
          'CCTV Pole 번호는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!cctvInfo.atdrc_id) {
      Swal.fire(
          '자치구는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!cctvInfo.locplc_addr) {
      Swal.fire(
          '설치주소는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!cctvInfo.la || !cctvInfo.lo) {
      Swal.fire(
          '설치위치(위도/경도)는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }
    if (!cctvInfo.instl_de) {
      Swal.fire(
          '설치일자는 필수 항목입니다.',
          '',
          'error'
      );
      return;
    }

    if (!propCctvNo) {
      // 등록
      console.log(cctvInfo);
      regCmnctCctvInfo(cctvInfo)
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
              hClose();
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    } else {
      // 수정
      let newInfo = {...cctvInfo};
      newInfo.cctv_no = propCctvNo;
      setCctvInfo(newInfo);

      console.log(cctvInfo);

      putCmnctCctvInfo(cctvInfo)
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              Swal.fire(
                  '정상적으로 처리 되었습니다!',
                  '',
                  'success'
              );
              hClose();
            }
          })
          .catch(err => {
            Swal.fire(
                err.response.data.message,
                '',
                'error'
            );
          });
    }

  };

  const viewImage = () => {
    Swal.fire({
      imageUrl: 'data:image/png;base64,' + cctvInfo.image_data,
      confirmButtonText: `확인`,
    })
  }

  const onDelImg = () => {
    const cctv_no = cctvInfo.cctv_no;

    Swal.fire({
      title: `첨부된 이미지를 삭제하시겠습니까?`,
      // imageUrl: 'data:image/png;base64,' + cctvInfo.image_data,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
        delCmnctCctvImg(cctv_no)
            .then((res) => {
              Swal.fire(
                  '삭제되었습니다!',
                  '',
                  'success'
              );
              setCctvInfo({...cctvInfo, image_data: ''});
            })
            .catch(err => {
              Swal.fire(
                  err.response.data.message,
                  '',
                  'error'
              );
            });
      }
    })
  }

  return (
      <Row className={"layer"}>
        <Col className={''}>
          <Row className={'info-container py-2 mx-3'}>
            <Col md={11} className={'px-5'}>
              <div className={'content-container-body-item'}>
                <Form
                    className={'gateway-register-form py-3'}
                    id={'firmwareRegisterForm'}
                >
                  <Row className={"justify-content-center"}>
                    <Col md={12}>
                      <Row>
                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>CCTV명
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('cctv_nm', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.cctv_nm : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.cctv_nm : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp1Addr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>CCTV Pole 번호
                            </Form.Label>
                            <Col md={8} className={''}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('cctv_pole_no', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.cctv_pole_no : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.cctv_pole_no : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end'}>
                              CCTV 모델
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('modl', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.modl : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.modl : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <ComboDistrict
                              propOnChange={(e) => onChangeInfo('atdrc_id', e.target.value)}
                              propIsSearch={false}
                              propRatio={4}
                              propLocation={"FIELD"}
                              propValue={cctvInfo.atdrc_id}
                          />
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>설치주소
                            </Form.Label>
                            <Col md={6}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('locplc_addr', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.locplc_addr : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.locplc_addr : '' || ''}
                                  required
                              />
                            </Col>
                            <Col md={2}>
                              <Button type={"button"} variant={"primary"} disabled={true}>지도</Button>
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='forml2IpAddr'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>설치위치 (위도/경도)
                            </Form.Label>
                            <Col md={4}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('la', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.la : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.la : '' || ''}
                                  required
                              />
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo('lo', e.target.value);
                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.lo : '' || ''}
                                  value={(cctvInfo !== null) ? cctvInfo.lo : '' || ''}
                                  required
                              />
                            </Col>
                          </Form.Group>
                        </Col>


                        <Col md={12}>
                          <Form.Group as={Row} controlId='formInstlDe'>
                            <Form.Label column md={4} className={'label text-end fw-bold'}>
                              <span className={"text-danger"}>* </span>설치일자
                            </Form.Label>
                            <Col md={8} className={''}>
                              <DatePicker
                                  onChange={(date) => {
                                    onChangeInfo('instl_de', Moment(date).format('YYYY-MM-DD'));
                                  }}
                                  value={cctvInfo.instl_de ? new Date(cctvInfo.instl_de) : new Date()}
                                  format={"yyyy-MM-dd"}
                                  clearIcon={null}
                                  className={"datepicker-start w-100 text-center"}
                                  calendarType={'US'}
                                  formatDay={
                                    (locale, date) => new Intl.DateTimeFormat(
                                        'en-US',
                                        {
                                          day: "numeric"
                                        }).format(date)
                                  }
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        {/*<Col md={12}>
                          <Form.Group as={Row} controlId='formIp2Addr'>
                            <Form.Label column md={4} className={'label text-end'}>
                              설치도면
                            </Form.Label>
                            <Col md={5}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  onChange={(e) => {
                                    onChangeInfo(['image_file_nm', 'filepath'],
                                        [e.target.value, e.target.files[0]], true);

                                  }}
                                  // defaultValue={(cctvInfo !== null) ? cctvInfo.image_file_nm : ''}
                                  // value={cctvInfo.image_file_nm || ''}
                              />
                            </Col>
                            <Col md={3}>
                              <Button type={"button"}
                              onClick={viewImage} disabled={cctvInfo.image_file_nm ? false : true}>
                                보기
                              </Button>
                              <span> </span>
                              <Button type={"button"}
                              onClick={onDelImg}>
                                삭제
                              </Button>
                            </Col>
                          </Form.Group>
                        </Col>*/}

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                              설치도면
                            </Form.Label>
                            <Col md={8}>
                              <Form.Control
                                  type='file'
                                  className={'input text-white'}
                                  /*onChange={(e) => {
                                    setGatewayData({
                                      ...gatewayData,
                                      filepath: e.target.files[0]
                                    })
                                  }}*/
                                  onChange={(e) => {
                                    onChangeInfo('filepath', e.target.files[0]);
                                  }}
                              />
                            </Col>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <Form.Group as={Row} controlId='formUseStatus'>
                            <Form.Label column md={4} className={'label text-end'}>
                            </Form.Label>
                            <Col md={5}>
                              <Form.Control
                                  type='text'
                                  className={'input text-white'}
                                  value={cctvInfo.image_file_nm || ''}
                                  readOnly={true}
                              />
                            </Col>
                            <Col md={3}>
                              <Button type={"button"}
                                      onClick={viewImage}
                                      disabled={cctvInfo.image_data ? false : true}
                              >
                                보기
                              </Button>
                              <span> </span>
                              <Button type={"button"}
                                      variant={"danger"}
                                      onClick={onDelImg}
                                      disabled={cctvInfo.image_data ? false : true}
                              >
                                삭제
                              </Button>
                            </Col>
                          </Form.Group>
                        </Col>

                      </Row>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
          <Row className={"my-3 justify-content-center"}>
            <Col md={2} className={'justify-content-center'}>
              <Button
                  className={'btn save-btn w-100'}
                  onClick={onSubmit}
              >저장</Button>
            </Col>
            <Col md={2} className={'justify-content-center text-end'}>
              <Button className={'btn btn-secondary w-100'} onClick={hClose}>취소</Button>
            </Col>
          </Row>
        </Col>
      </Row>
  );
};


export default ConfCctvReg;
